import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { DiscoveryIcon } from '../global/CustomIcons';

import PageBreadcrumbs from '../common/PageBreadcrumbs';
import InsightsBrief from './InsightsBrief';

/* Sidebar · Intelligence · Discovery — the Workspace Intelligence Brief:
   what moved, what leads what, what repeats, what broke, and what to
   watch — computed deterministically over every signal, narrated by the
   analysis worker's LLM pass. Goal-conditioned driver discovery lives
   under Actions → Goals; this page is the always-on radar. */

const DiscoveryInsightsPage = () => (
  <Box sx={{ width: '100%', position: 'relative', mb: 4 }}>
    <Stack sx={{ mb: 1.5 }}>
      <PageBreadcrumbs
        items={[{ text: 'Discovery', icon: <DiscoveryIcon /> }]}
        mb={0.5}
      />
      <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
        Your data's intelligence brief — what moved, what leads what, what
        repeats, and what to watch. Refreshed automatically as new data lands.
      </Typography>
    </Stack>

    <InsightsBrief />
  </Box>
);

export default DiscoveryInsightsPage;
